/*
Replace
nft with your resource Name :) Take care about different writings!
/!\ Nft nft Nfts nfts /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
  defaultRemove,
  defaultRemoveSuccess,
  defaultRemoveFail,
  defaultRemoveReset,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const faqListsSlice = createSlice({
  name: "faqLists",
  initialState: { ...defaultInitialState, showMeta: {} },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: (state, action) => {
      state.loadingShow = false;
      state.loadedShow = true;
      state.show = action.payload.data;
      state.showId = action.payload.data.id;
      state.dictionary[action.payload.data.id] = action.payload.data;
      state.errorsObject = null;
      state.showMeta = action.payload.meta;
    },
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
    remove: defaultRemove,
    removeSuccess: defaultRemoveSuccess,
    removeFail: defaultRemoveFail,
    removeReset: defaultRemoveReset,
    createSuccessReset: (state, action) => {
      state.created = false;
    },
    updateErrorReset: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = null;
    },
    listErrorReset: (state, action) => {
      state.listing = false;
      state.listed = false;
      state.listError = null;
    },
    createErrorReset: (state, action) => {
      state.creating = false;
      state.created = false;
      state.createError = null;
    },
    showErrorReset: (state, action) => {
      state.showing = false;
      state.showed = false;
      state.showError = null;
      state.unlockError = null;
      state.unlockSuccess = false;
    },
  },
});

export const {
  show: showFaqList,
  update: updateFaqList,
  list: listFaqLists,
  create: createFaqList,
  updateErrorReset: updateFaqListErrorReset,
  listErrorReset: listFaqListsErrorReset,
  createErrorReset: createFaqListErrorReset,
  showErrorReset: showFaqListErrorReset,
  createSuccessReset: createFaqListSuccessReset,
  remove: removeFaqList,
  removeReset: removeFaqListReset,
} = faqListsSlice.actions;
export const actions = faqListsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const faqLists = (state) =>
  state.faqLists.idsList.map((id) => state.faqLists.dictionary[id]);
export const faqList = (state) =>
  state.faqLists.showId && state.faqLists.dictionary[state.faqLists.showId];
export const faqListAttributes = (state) => faqList(state)?.attributes;
export const faqListRelationships = (state) => faqList(state)?.relationships;
export const faqListId = (state) => state.faqLists.showId;

export const getFaqList = createSelector(
  (state) => state.faqLists.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getFaqListAttributes = createSelector(
  (state) => state.faqLists.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getFaqListRelationships = createSelector(
  (state) => state.faqLists.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getFaqLists = createSelector(
  (state) => state.faqLists.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export const getFaqListFormData = createSelector(
  (state) => state.faqLists.dictionary,
  (state) => state.faqListsFaqs.dictionary,
  (state) => state.faqs.dictionary,
  (_, id) => id,
  (dictionary, faqListFaqsDictionary, faqsDictionary, id) => {
    const faqList = dictionary && dictionary[id];
    if (!faqList) return null;
    let faqListData = { ...faqList?.attributes };
    console.log("sata", faqListData);
    const faqListFaqsIds = faqList?.relationships?.faq_lists_faqs?.data?.map(
      (faqListFaq) => faqListFaq.id
    );
    faqListData["faq_lists_faqs_attributes"] = faqListFaqsIds?.map(
      (faqListFaqId) => {
        const faqListFaq = faqListFaqsDictionary[faqListFaqId];
        const faqId = faqListFaq?.attributes?.faq_id;
        const faqTitle = faqsDictionary[faqId]?.attributes?.title;
        return {
          faq_id: { label: faqTitle, value: faqId },
          faq_title: faqTitle,
          faqId,
          faq_content: faqsDictionary[faqId]?.attributes?.content,
          id: faqListFaqId,
        };
      }
    );
    return faqListData;
  }
);

export const getFaqListBySlug = createSelector(
  (state) => state.faqLists.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    return dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ];
  }
);

export const getFaqListIdBySlug = createSelector(
  (state) => state.faqLists.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    const entry = dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ];
    return entry?.id;
  }
);

export const getFaqListAttributesBySlug = createSelector(
  (state) => state.faqLists.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    return dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ]?.attributes;
  }
);

export const getFaqListRelationshipsBySlug = createSelector(
  (state) => state.faqLists.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    return dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ]?.relationships;
  }
);

export default faqListsSlice.reducer;
